<div class="navbar-area">
    <div class="mobile-nav">
        <a routerLink="/" class="logo"><img width="72" src="assets/img/logo.png" alt="Logo"></a>
    </div>

    <div class="side-nav-responsive">
        <div class="container">
            <div class="dot-menu">
                <div class="circle-inner">
                    <div class="circle circle-one"></div>
                    <div class="circle circle-two"></div>
                    <div class="circle circle-three"></div>
                </div>
            </div>
            
            <div class="container">
                <div class="side-nav-inner">
                    <div class="side-nav text-start">
                          <div class="side-item">
                            <div class="user-btn">
                                <ul class="navbar-nav m-auto text-start">
                                    <!-- <li *ngIf="isLogged" class="nav-item"><a routerLink="/login-register" class="nav-link" routerLinkActive="active"[routerLinkActiveOptions]="{exact: true}" (click)="logOut()">تسجيل خروج</a></li> -->
                                    <a style="cursor: pointer;" *ngIf="!isLogged" data-bs-toggle="modal" data-bs-target="#authModal" class="nav-link"><i class='bx bxs-user'></i> Login / Register</a>
                                    <a class="nav-link" href="tel:{{phoneNumber}}"><i class='bx bxs-phone'></i> Call Us</a>
                                    <a routerLink="/account" *ngIf="isLogged" class="nav-link"><i class='bx bx-user'></i> My Account</a>
                                    <a routerLink="/account" *ngIf="isLogged" class="nav-link"><i class='bx bx-list-ol'></i> My Orders</a>
                                    <a routerLink="/cart" class="nav-link"><i class='bx bx-cart'></i> Cart</a>
                                    <a routerLink="/wishlist" class="nav-link"><i class='bx bx-heart'></i> Wishlist</a>
                                    <a style="cursor: pointer;" (click)="logOut()" *ngIf="isLogged" class="nav-link"><i class='bx bx-door-open'></i> Sing Out</a>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="main-nav">
        <div class="container">
            <nav class="navbar navbar-expand-md navbar-light">
                <a class="navbar-brand" routerLink="/"><img width="72" src="assets/img/logo.png" alt="Logo"></a>

                <div class="collapse navbar-collapse mean-menu" id="navbarSupportedContent">
                    <ul class="navbar-nav m-auto">
                        <li class="nav-item" [class.active]="isActive('/', true)">
                            <a routerLink="/" class="nav-link">Home</a>
                        </li>

                        <li class="nav-item" [class.active]="isActive('/offers')">
                            <a routerLink="/offers" class="nav-link">Offers</a>
                        </li>

                        <li class="nav-item" [class.active]="isActive('/order-apps')">
                            <a routerLink="/order-apps" class="nav-link">Order Apps</a>
                        </li>

                        <li class="nav-item" [class.active]="isActive('/menu')">
                            <a routerLink="/menu" class="nav-link">Menu</a>
                        </li>

                        <li class="nav-item" [class.active]="isActive('/about')">
                            <a routerLink="/about" class="nav-link">About</a>
                        </li>

                    </ul>

                    <div *ngIf="isLogged" class="menu-btn" style="top: 0;">
                      <div class="user-btn">
                        <ul class="navbar-nav m-auto">
                          <li *ngIf="isLogged" class="nav-item dropdownItem p-0">
                              <a href="javascript:void(0)" class="nav-link phone-btn p-0" style="padding-top: 4px !important;">
                                  <i class='bx bxs-user'></i>
                              </a>
                              <ul class="dropdown-menu">
                                  <li class="nav-item">
                                      <a routerLink="/account" class="nav-link" routerLinkActive="active">Profile</a>
                                  </li>
                                  <li class="nav-item">
                                      <a routerLink="/account" class="nav-link" routerLinkActive="active">My Orders</a>
                                  </li>
                                  <li class="nav-item">
                                      <a (click)="logOut()" class="nav-link" routerLinkActive="active">Sign Out</a>
                                  </li>
                              </ul>
                          </li>
                        </ul>
                      </div>
                    </div>

                    <div class="menu-btn">
                      <a *ngIf="!isLogged" class="nav-link" class="phone-btn" data-bs-toggle="modal" data-bs-target="#authModal"><i class='bx bxs-user'></i> Login / Register</a>
                      <!-- <a  class="nav-link" id="userListMenu" class="phone-btn"><i class='bx bxs-user'></i> </a> -->
                    </div>
                    

                    <div class="menu-btn vibration">
                        <a href="tel:{{phoneNumber}}" class="phone-btn"><i class='bx bxs-phone'></i></a>
                    </div>

                    <div class="menu-btn vibration">
                        <a routerLink="/cart" class="phone-btn"><i class='bx bx-cart'></i></a>
                    </div>

                    <div class="menu-btn vibration">
                        <a routerLink="/wishlist" class="phone-btn"><i class='bx bx-heart'></i></a>
                    </div>
                    
                    <!-- <div class="cart-area">
                        <a routerLink="/cart"><i class='bx bx-cart'></i></a>
                    </div> -->

                </div>
            </nav>
        </div>
    </div>

    

</div>

<!-- Modal -->
<div class="modal fade" id="authModal" tabindex="-1" aria-labelledby="authModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-lg modal-dialog-centered">
    <div class="modal-content">
      <!-- Modal Header with Tabs -->
      <div class="modal-header border-0 p-0">
        <ul class="nav nav-tabs w-100" id="authTabs" role="tablist">
          <li class="nav-item w-50" role="presentation">
            <button class="nav-link active w-100 py-3" style="border-top-left-radius: 32px;" id="signin-tab" data-bs-toggle="tab" 
                    data-bs-target="#signin-content" type="button" role="tab" 
                    aria-controls="signin-content" aria-selected="true">
              <h5 class="mb-0">Sign In</h5>
            </button>
          </li>
          <li class="nav-item w-50" role="presentation">
            <button class="nav-link w-100 py-3" style="border-top-right-radius: 32px;" id="signup-tab" data-bs-toggle="tab" 
                    data-bs-target="#signup-content" type="button" role="tab" 
                    aria-controls="signup-content" aria-selected="false" (click)="initAutocomplete()">
              <h5 class="mb-0">Sign Up</h5>
            </button>
          </li>
        </ul>
        <button type="button" class="btn-close position-absolute end-0 mt-2 me-2" 
          data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      
      <!-- Modal Body with Tab Content -->
      <div class="modal-body p-4 pt-3">
        <div class="tab-content" id="authTabsContent">
          <!-- Sign In Form -->
          <div class="tab-pane fade show active" id="signin-content" role="tabpanel" 
               aria-labelledby="signin-tab">
            <form [formGroup]="signInForm" id="signinForm" (ngSubmit)="login()">
              <div class="mb-3">
                <label for="signin-email" class="form-label">Email address or Phone<span class="text-danger">*</span></label>
                <input type="email" class="form-control" id="signin-email" 
                  placeholder="1234567890" name="phone" formControlName="phone" required>
              </div>
              <div class="">
                <label for="signin-password" class="form-label">Password<span class="text-danger">*</span></label>
                <input type="password" class="form-control" name="password" formControlName="password"
                  placeholder="****************" id="signin-password" required>
                <div *ngIf="signInForm.get('password')?.hasError('required') && signInForm.get('password')?.touched" class="text-danger">
                  Password is required
                </div>
                <div *ngIf="signInForm.get('password')?.hasError('minlength') && signInForm.get('password')?.touched" class="text-danger">
                  Password must be at least 8 characters
                </div>
              </div>
              <a style="color: #C71D1D;" class="mb-3" href="/reset-password">Forgot password?</a>
              <div class="d-grid gap-2">
                <button type="submit" class="btn btn-primary py-2" [disabled]="isLoading">
                  <span *ngIf="isLoading" class="spinner-border spinner-border-sm me-1"></span>
                  Sign In
                </button>
              </div>
              <div class="d-grid gap-2">
                <a (click)="enableGuestMode()" class="link">Continue as a guest</a>
              </div>
            </form>

            <form id="codeOTPErrorWhenLogin" class="d-none" *ngIf="currentStep === 1" [formGroup]="resetForm" (ngSubmit)="sendOtpToMailIfLoginFailed()">
              <div class="row">
                  <div class="col-12">
                      <div class="form-group mb-2">
                          <label for="email" class="form-label">Email <span class="text-danger">*</span></label>
                          <input class="form-control" type="email" name="email" formControlName="email" placeholder="Enter Your Email">
                          <div *ngIf="resetForm.get('email')?.hasError('required') && resetForm.get('email')?.touched" class="text-danger text-small ps-3 mt-0">
                            Email is required
                          </div>
                          <div *ngIf="resetForm.get('email')?.hasError('email') && resetForm.get('email')?.touched" class="text-danger text-small ps-3 mt-0">
                            Enter a valid email address
                          </div>
                      </div>
                  </div>

                  <div class="col-12 text-center">
                      <button class="btn btn-primary" type="submit" [disabled]="isLoading">
                          <span *ngIf="isLoading" class="spinner-border spinner-border-sm me-1"></span>
                          Send OTP
                      </button>
                  </div>
              </div>
            </form>
            <!-- Step 2: OTP Verification -->
            <div class="scetion-title text-center" *ngIf="currentStep === 2">
                <span style="color: #C71D1D;">Verify OTP</span>
                <h2>Enter Verification Code</h2>
                <p class="recover-text">We've sent a 6-digit code to <strong>{{resetForm.value.email}}</strong></p>
                
                <form [formGroup]="otpCodeForm" (ngSubmit)="verifyOtp2()">
                    <div class="row justify-content-center">
                        <div class="col-12">
                            <div class="otp-input-group">
                                <input type="text" maxlength="1" (input)="moveToNext2($event, 1)" #otp1>
                                <input type="text" maxlength="1" (input)="moveToNext2($event, 2)" #otp2>
                                <input type="text" maxlength="1" (input)="moveToNext2($event, 3)" #otp3>
                                <input type="text" maxlength="1" (input)="moveToNext2($event, 4)" #otp4>
                                <input type="text" maxlength="1" (input)="moveToNext2($event, 5)" #otp5>
                                <input type="text" maxlength="1" (input)="moveToNext2($event, 6)" #otp6>
                            </div>
                            <input type="hidden" formControlName="otp_code">
                            <div *ngIf="otpCodeForm.get('otp_code')?.hasError('required')" class="text-danger text-small text-center mt-2">
                                OTP is required
                            </div>
                        </div>
                        <div class="col-12 text-end mt-4">
                          <span class="text-muted" *ngIf="countdown > 0">
                            {{countdown}} seconds
                          </span>
                        </div>
                        <div class="col-12 text-center mt-4">
                            <button class="btn btn-primary me-2" type="submit" [disabled]="isLoading">
                                <span *ngIf="isLoading" class="spinner-border spinner-border-sm me-1"></span>
                                Verify
                            </button>
                            <button class="btn btn-outline-secondary" type="button" (click)="resendOtp()" [disabled]="disableBtnBeforeResendOTP">
                                <span *ngIf="isResending" class="spinner-border spinner-border-sm me-1"></span>
                                Resend OTP
                            </button>
                        </div>
                    </div>
                </form>
            </div>
          </div>
          
          <!-- Sign Up Form -->
          <div class="tab-pane fade" id="signup-content" role="tabpanel" 
               aria-labelledby="signup-tab">
            <form [formGroup]="signupForm" id="signupForm" *ngIf="!showOtpVerification">
              <div class="mb-3">
                <label for="signup-name" class="form-label">Full Name<span class="text-danger">*</span></label>
                <input type="text" name="name" formControlName="name" placeholder="John Doe" class="form-control" id="signup-name" required>
                <div *ngIf="signupForm.get('name')?.hasError('required') && signupForm.get('name')?.touched" class="text-danger">
                  <small>Name is required</small>
                </div>
              </div>
              <div class="mb-3">
                <label for="signup-phone" class="form-label">Phone Number<span class="text-danger">*</span></label>
                <input name="phone" formControlName="phone" type="tel" placeholder="123-456-7890" (input)="formatPhoneNumber($event)" class="form-control" id="signup-phone" required>
                <div *ngIf="signupForm.get('phone')?.hasError('required') && signupForm.get('phone')?.touched" class="text-danger">
                  <small>Phone number is required</small>
                </div>
                <div *ngIf="signupForm.get('phone')?.hasError('pattern') && signupForm.get('phone')?.touched" class="text-danger">
                  <small>Phone number must be in the format 123-456-7890</small>
                </div>
              </div>
              <div class="mb-3">
                <label for="signup-email" class="form-label">Email Address<span class="text-danger">*</span></label>
                <input type="email" class="form-control" id="signup-email"  formControlName="email" name="email"
                  placeholder="name@example.com" required>
                <div *ngIf="signupForm.get('email')?.hasError('required') && signupForm.get('email')?.touched" class="text-danger">
                  <small>Email address is required</small>
                </div>
                <div *ngIf="signupForm.get('email')?.hasError('email') && signupForm.get('email')?.touched" class="text-danger">
                  <small>Email address is invalid</small>
                </div>
              </div>
              <!-- <div class="mb-3">
                <label for="gender" class="form-label">Gender<span class="text-danger">*</span></label>
                <select class="form-control w-100" id="gender" formControlName="gender" name="gender">
                  <option value="">Please select your gender</option>
                  <option value="male">Male</option>
                  <option value="female">Female</option>
                </select>
                <div *ngIf="signupForm.get('gender')?.hasError('required') && signupForm.get('gender')?.touched" class="text-danger">
                  <small>Gender is required</small>
                </div>
              </div> -->
              <div class="mb-3">
                <label for="signup-address" class="form-label">Address<span class="text-danger">*</span></label>
                <input type="text" id="addressInput" name="address" formControlName="address" 
                  class="form-control" placeholder="Start typing your address...">
                <!-- <input name="address" formControlName="address" type="text" placeholder="123 Main St" 
                 class="form-control" id="signup-address" required> -->
                <div *ngIf="signupForm.get('address')?.hasError('required') && signupForm.get('address')?.touched" class="text-danger">
                  <small>Please enter your address</small>
                </div>
              </div>
              <div class="row">
                <div class="col-lg-4">
                  <div class="mb-3">
                    <label for="signup-building" class="form-label">Building</label>
                    <input name="building" formControlName="building" type="text" placeholder="Ex: 10" class="form-control" id="signup-building" required>
                    <!-- <div *ngIf="signupForm.get('building')?.hasError('required') && signupForm.get('building')?.touched" class="text-danger">
                      <small>Please enter your building</small>
                    </div> -->
                  </div>
                </div>
                <div class="col-lg-4">
                  <div class="mb-3">
                    <label for="signup-floor" class="form-label">Floor</label>
                    <input name="floor" formControlName="floor" type="text" placeholder="Ex: 2" class="form-control" id="signup-floor" required>
                    <!-- <div *ngIf="signupForm.get('floor')?.hasError('required') && signupForm.get('floor')?.touched" class="text-danger">
                      <small>Please enter your floor</small>
                    </div> -->
                  </div>
                </div>
                <div class="col-lg-4">
                  <div class="mb-3">
                    <label for="signup-flat" class="form-label">Flat</label>
                    <input name="flat" formControlName="flat" type="text" placeholder="Ex: 101" class="form-control" id="signup-flat" required>
                    <!-- <div *ngIf="signupForm.get('flat')?.hasError('required') && signupForm.get('flat')?.touched" class="text-danger">
                      <small>Please enter your flat</small>
                    </div> -->
                  </div>
                </div>
              </div>
              <div class="mb-3">
                <label for="signup-special_mark" class="form-label">Special Mark</label>
                <input name="special_mark" formControlName="special_mark" type="text" placeholder="Any special landmarks or directions" class="form-control" id="signup-special_mark" required>
                <!-- <div *ngIf="signupForm.get('special_mark')?.hasError('required') && signupForm.get('special_mark')?.touched" class="text-danger">
                  <small>Please enter your special mark</small>
                </div> -->
              </div>
              <div class="mb-3">
                <label for="signup-password" class="form-label">Password<span class="text-danger">*</span></label>
                <input type="password" name="password" formControlName="password" placeholder="****************" class="form-control" id="signup-password" required>
                <div *ngIf="signupForm.get('password')?.errors">
                  <small class="text-danger" *ngIf="signupForm.get('password')?.hasError('required')">
                    Password is required
                  </small>
                  <small class="text-danger" *ngIf="signupForm.get('password')?.hasError('minlength')">
                    Password must be at least 8 characters
                  </small>
                </div>
              </div>
              <div class="mb-3">
                <label for="signup-confirm-password" class="form-label">Confirm Password<span class="text-danger">*</span></label>
                <input type="password" name="password_confirmation" formControlName="password_confirmation" placeholder="****************" class="form-control" id="signup-confirm-password" required>
                <div *ngIf="signupForm.get('password_confirmation')?.errors">
                  <small class="text-danger" *ngIf="signupForm.get('password_confirmation')?.hasError('required')">
                    Please confirm your password
                  </small>
                </div>
                <div *ngIf="signupForm.hasError('mismatch')" class="text-danger">
                  <small class="text-danger">
                    Passwords do not match
                  </small>
                </div>
              </div>
              <div class="d-grid gap-2">
                <button type="submit" class="btn btn-primary py-2" (click)="submitSignup()" [disabled]="isLoading">
                  <span *ngIf="isLoading" class="spinner-border spinner-border-sm me-1"></span>
                  Sign Up
                </button>
              </div>
              <div class="d-grid gap-2">
                <a (click)="enableGuestMode()" class="link">Continue as a guest</a>
              </div>
            </form>
            <form class="verification-otp" *ngIf="showOtpVerification">
              <div class="text-center mb-4">
                <h5>Verify Your Email</h5>
                <p class="text-muted">We've sent a 6-digit code to {{userEmail}}</p>
              </div>
              
              <div class="otp-input-group mb-4">
                <input type="text" maxlength="1" class="form-control otp-digit" 
                      *ngFor="let box of [0,1,2,3,4,5]; let i = index"
                      [(ngModel)]="otp[i]" 
                      [ngModelOptions]="{standalone: true}"
                      (keyup)="moveToNext($event, i)">
              </div>
              
              <div class="d-flex justify-content-between mb-3">
                <button type="button" class="btn btn-link" [disabled]="countdown != 0" (click)="resendOtp()">
                  Resend Code
                </button>
                <span class="text-muted" *ngIf="countdown > 0">
                  {{countdown}} seconds
                </span>
              </div>
              
              <div class="d-grid gap-2">
                <button type="button" class="btn btn-primary py-2" 
                        [disabled]="!isOtpComplete()" 
                        (click)="verifyOtp()">
                  Verify & Continue
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>